// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"MenuItem_menuItem__22Hzp","icon":"MenuItem_icon__13emC","active":"MenuItem_active__3zHYA"};